<script>
export default {
  name: 'WithFirstBillingDate',
  props: {
    firstBillingDate: { type: String, required: true },
  },
};
</script>
